//
//
//
//
//
//
//
//
export default {
  name: "SettingItem",
  props: {
    title: {
      type: String,
      default: ''
    },
    divider: {
      type: Boolean,
      default: false
    }
  }
};